export const getUploadUrl = (filePath) => {
  if (!filePath) {
    return '';
  }

  const cleanPath = String(filePath).trim().replace(/^\/+/, '');

  if (/^https?:\/\//i.test(cleanPath)) {
    return cleanPath;
  }

  const uploadBase =
    process.env.REACT_APP_BACKEND_URL_REL ||
    `${process.env.REACT_APP_BACKEND || 'http://localhost:8001/'}uploads/`;
  const base = uploadBase.endsWith('/') ? uploadBase : `${uploadBase}/`;

  return `${base}${cleanPath.replace(/^uploads\//, '')}`;
};
